import { TGrupoConcessionaria } from './groupDealer.types';
import { NavigateFunction } from "react-router-dom";
import { BaseClient } from '../client';

interface setGroupDealerProps {
    grupoConcessionaria: string;
    tagAtivo: boolean;
    logotipo: File | null;
    idUserIndicador?: number;
    setToast: (toast: { message: string, variant: 'success' | 'error' }) => void;
    navigate: NavigateFunction;
    
}

export const postGroupDealer = async (dealerProps: setGroupDealerProps) => {
    // if (process.env.NODE_ENV === 'development') {
    // 	return 'Alterado com sucesso';
    // }

    try {
        const formData = new FormData();
        formData.append('Descricao', dealerProps.grupoConcessionaria);
        formData.append('Ativo', dealerProps.tagAtivo.toString());
        if (dealerProps.idUserIndicador) {
            formData.append('IdUserIndicador', String(dealerProps.idUserIndicador));
        }
        if (dealerProps.logotipo) {
            formData.append('Logotipo', dealerProps.logotipo);
        }

        const response = await BaseClient.post<TGrupoConcessionaria[]>(`v2/Concessionaria/CadastrarGrupoConcessionaria`,formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );

        if (response.status === 200) {
            dealerProps.navigate(`/cadastros/grupo-concessionarias`);
            dealerProps.setToast({
                message: 'Concessionária criada com sucesso!',
                variant: 'success',
            });
            return response.data; 
        } else {
            dealerProps.navigate(`/cadastros/grupo-concessionarias/novo`);
            dealerProps.setToast({
                message: 'Erro ao criar a concessionária. Tente novamente.',
                variant: 'error',
            });
        }

        return response.data;
    } catch (error) {
        console.error(error);
        dealerProps.navigate(`/cadastros/grupo-concessionarias/novo`);
        dealerProps.setToast({
            message: 'Erro ao criar a concessionária. Tente novamente.',
            variant: 'error',
        });
    }
};
